import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";

interface UtilitariosState {
    fetching: FetchingTypes;
    utilitarios: {
        utilitarios: any[];
        fetching: FetchingTypes;
    };
    publications: {
        fetching: FetchingTypes;
        utilitarios: any[];
    };
    publicationById: {
        fetching: FetchingTypes;
        publication: any;
    };
}

const initialState: UtilitariosState = {
    fetching: "unknown",
    utilitarios: {
        fetching: "unknown",
        utilitarios: []
    },
    publications: {
        fetching: "unknown",
        utilitarios: []
    },
    publicationById: {
        fetching: "unknown",
        publication: []
    }
};

const utilitariosSlice = createSlice({
    name: "utilitarios",
    initialState,
    reducers: {
        getUtilitariosRequest: (state) => {
            state.utilitarios.fetching = "loading";
        },
        getUtilitariosSuccess: (state, action) => {
            state.utilitarios.fetching = "success";
            state.utilitarios.utilitarios = action.payload.utilitarios;
        },
        getUtilitariosFailure: (state) => {
            state.utilitarios.fetching = "failure";
            state.utilitarios = initialState.utilitarios;
        },
        getUtilitariosPublicationsRequest: (state) => {
            state.publications.fetching = "loading";
        },
        getUtilitariosPublicationsSuccess: (state, action) => {
            state.publications.fetching = "success";
            state.publications.utilitarios = action.payload.utilitarios;
        },
        getUtilitariosPublicationsFailure: (state) => {
            state.publications.fetching = "failure";
            state.publications.utilitarios = initialState.publications.utilitarios;
        },
        getUtilitariosPublicationsByIdRequest: (state) => {
            state.publicationById.fetching = "loading";
        },
        getUtilitariosPublicationsByIdSuccess: (state, action) => {
            state.publicationById.fetching = "success";
            state.publicationById.publication = action.payload.publication;
        },
        getUtilitariosPublicationsByIdFailure: (state) => {
            state.publicationById.fetching = "failure";
            state.publicationById.publication = initialState.publicationById.publication;
        },
        cleanUtilitarios: () => initialState
    }
});

export const {
    getUtilitariosRequest,
    getUtilitariosSuccess,
    getUtilitariosFailure,
    getUtilitariosPublicationsRequest,
    getUtilitariosPublicationsSuccess,
    getUtilitariosPublicationsFailure,
    getUtilitariosPublicationsByIdRequest,
    getUtilitariosPublicationsByIdSuccess,
    getUtilitariosPublicationsByIdFailure,
    cleanUtilitarios,
} = utilitariosSlice.actions;

export default utilitariosSlice.reducer;